/**
 * Pronouns for referring to a client in messages to their trainer, so the grammar is right. Gender is used
 * for this only — never to change tone or content. Anything other than woman/man (including not set) is "they".
 */
export interface Pronouns {
  they: string;
  them: string;
  their: string;
  /** true for "they" (they opt / they've), false for she/he (she opts / she's) */
  plural: boolean;
}
export function pronouns(gender?: string | null): Pronouns {
  if (gender === "woman") return { they: "she", them: "her", their: "her", plural: false };
  if (gender === "man") return { they: "he", them: "him", their: "his", plural: false };
  return { they: "they", them: "them", their: "their", plural: true };
}
/** "they've" / "she's" */
export const haveContracted = (p: Pronouns) => (p.plural ? `${p.they}'ve` : `${p.they}'s`);
/** Verb in the present tense: verbFor(p, "opt") → "opt" | "opts"; "train" → "train" | "trains". */
export const verbFor = (p: Pronouns, verb: string) => (p.plural ? verb : /(s|sh|ch|x|z)$/.test(verb) ? `${verb}es` : `${verb}s`);
export const capital = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
